import { Component, OnInit, Input, Output, EventEmitter, ViewChild, Directive, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { REDEEM_INVESTOR } from '../../../models/Redeem';
import { ISSUANCE_INVESTOR, ISSUE } from '../../../models/Issuance';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../../../header.service';
import { ProfileService } from '../../../profile.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { PaginationComponent } from "../../../pagination/pagination.component";
import * as Globals from '../../../globals';
import { ISSUE_ACCOUNTS } from 'app/models/account';
const url = Globals.serviceUrl;
declare var $: any;

@Component({
  selector: 'app-custompemesanan-detail',
  templateUrl: './custompemesanan-detail.component.html',
  styleUrls: ['./custompemesanan-detail.component.css']
})

export class CustompemesananDetailComponent implements OnInit {
  @ViewChild(PaginationComponent) subchild: PaginationComponent;
  param: any;
  tab: number = 2;
  @Input() seriesId: number;
  @Input() paramSeries: any;
  @Input() ssId: number;
  @Input() sid: string;
  @Output() refreshParent = new EventEmitter;
  @Input() userProfile: any;
  loading: boolean;
  p: any;
  errAmt: boolean;
  search: string;
  editIssue: boolean;
  selectedBidId: number;
  urlFile = Globals.archiveUrl + 'bids?code=';
  showError: boolean;
  all: boolean;
  issuances: any[];
  issue: ISSUE;
  SID: string;
  INV_NAME: string;
  BID_CODE: string;
  pagedList: any;
  pageNumber: number = 1;
  accountsBank: ISSUE_ACCOUNTS[];
  accountsSec: ISSUE_ACCOUNTS[];
  pageSize: number = 10;
  sort: string[] = ['BIDDATE'];
  totBids: number = 0;
  totBayar: number = 0;
  series: any[];
  bidCode: string;
  @Input() authMenu: any;
  @ViewChild("fileInput") fileInput: any;
  @ViewChild("issueAmt") issueAmtEl: any;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private router: Router) {
    this.toastr.setRootViewContainerRef(vRef);
    // this.issue = new ISSUE(0, 0, 0, 0, 0, 0, 0, this.userProfile.USER_ID, null, this.userProfile.GROUP_ID);
    this.authMenu = { M_FLAG: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/ritelonline/monitoring/pemesanan/0') {
          this.tab = 2;
          this.router.navigate(['/ritelonline/monitoring/pemesanan/2']);
        }
      };
    });
  }
  ngOnInit() {
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.getInvestorBids(1);
      this.authMenu = Globals.getAuthMenu(205, this.userProfile);
    }
    // this.accountsBanks = [];
    // this.accountsSecs = [];
    this.issue = new ISSUE(0, 0, 0, 0, 0, 0, 0, this.userProfile.USER_ID, null, this.userProfile.GROUP_ID,null,null);
  }

  getInvestorBids(pageNumber: number) {
    this.loading = true;
    this.all = true;
    //this.pagedList = {};
    this.issuances = [];
    this.http.get(url + 'ritel/bidsonline?seriesId=' + this.seriesId + '&sid=' + this.sid + '&ssId=' + this.ssId + '&pageNumber=' + pageNumber + '&pageSize=' + this.pageSize + '&sort=' + this.sort + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.pagedList = res.json();
        this.issuances = this.pagedList.Model.Records;
        this.pageNumber = pageNumber;
        this.subchild.getPagination(pageNumber, this.pagedList.Model);
        this.totBids = this.pagedList.Model.TotalNominal;
        this.totBayar = this.pagedList.Model.TotalBayar;
        this.SID = this.issuances[0].Sid;
        this.INV_NAME = this.issuances[0].InvestorName;
        this.BID_CODE = this.issuances[0].BidCode;
        this.getAccountsBank();
        this.getAccountsSec();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  pageChange(pageNumber: number) {
    if (this.all) {
      this.getInvestorBids(pageNumber);
    }
  }

  deleteBid() {
    this.loading = true;
    this.http.delete(url + 'ritel/bidsonline?bidCode=' + this.bidCode + '&sid=' + this.sid + '&ssId=' + this.ssId, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.toastr.success('Data berhasil dihapus');
        this.getInvestorBids(this.pageNumber);
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getAccountsBank() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/accountsBank?invid=' + this.issuances[0].InvId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.accountsBank = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getAccountsSec() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/accountsSec?invid=' + this.issuances[0].InvId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.accountsSec = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  setIssue(item: any) {
    this.issue.INV_ACCT_ID = item.InvAcctId;
    this.issue.SEC_ACCT_ID = item.SecAcctId;
    this.issue.INV_ACCT_NO = item.InvAcctNo;
    this.issue.SEC_ACCT_NO = item.SecAcctNo;
    this.issue.BID_ID = item.BidId;
  }
  changeAcctDana() {
    var itemd: any;
    for (var i = 0; i < this.accountsBank.length; i++) {
      if (this.accountsBank[i].BANK_ACCT_ID == this.issue.INV_ACCT_ID) {
        itemd = this.accountsBank[i];
        break;
      }
    }
    this.issue.INV_ACCT_ID = itemd.BANK_ACCT_ID;
  }

  changeAcctSb() {
    var items: any;
    for (var i = 0; i < this.accountsSec.length; i++) {
      if (this.accountsSec[i].SEC_ACCT_ID == this.issue.SEC_ACCT_ID) {
        items = this.accountsSec[i];
        break;
      }
    }
    this.issue.SEC_ACCT_ID = items.SEC_ACCT_ID;
  }
  saveAccount() {
    this.loading = true;
    this.http.put(Globals.serviceUrl + 'ritel/bidso?id=' + this.issue.BID_ID + '&seriesId=' + this.seriesId + '&invId=' + this.issuances[0].InvId, this.issue, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        // this.uploadFile(res.json().BID_ID, fi);
        this.issue = res.json();
        $('#issue').modal('hide');
        this.toastr.success('Data berhasil disimpan');
        this.getInvestorBids(1);
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });

  }
}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/ritel-online/custom-pemesanan/custompemesanan-detail/custompemesanan-detail.component.ts